import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import DerronLanding from "@/pages/DerronLanding";
import Home from "@/pages/Home";
import CasaDeLeon from "@/pages/CasaDeLeon";
import PuntaArena from "@/pages/PuntaArena";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPortals from "@/pages/AdminPortals";

function App() {
  return (
    <div className="App noise">
      <AuthProvider>
        <LanguageProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<DerronLanding />} />
            <Route path="/punto-nima" element={<SmoothScroll><Home /></SmoothScroll>} />
            <Route path="/casa-de-leon" element={<SmoothScroll><CasaDeLeon /></SmoothScroll>} />
            <Route path="/punta-arena" element={<PuntaArena />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminPortals />} />
            <Route path="/admin/:portal" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
